"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComboBox = void 0;
/* eslint-disable jsx-a11y/control-has-associated-label */
var react_1 = __importStar(require("react"));
var throttle_debounce_1 = require("throttle-debounce");
var ComboBoxOptionUtilities_1 = require("./helpers/ComboBoxOptionUtilities");
var Popover_1 = require("../Popover/Popover");
var useControlled_1 = __importDefault(require("./hooks/useControlled"));
var ComboBoxFocus_1 = __importDefault(require("./helpers/ComboBoxFocus"));
var StringUtilities_1 = __importDefault(require("./helpers/StringUtilities"));
var ComboBoxOption_1 = require("./components/ComboBoxOption");
var useAjaxQueue_1 = __importDefault(require("./hooks/useAjaxQueue"));
var ComboBoxTags_1 = __importDefault(require("./components/ComboBoxTags"));
var ComboBoxInput_1 = __importDefault(require("./components/ComboBoxInput"));
var ComboBoxClearButton_1 = __importDefault(require("./components/ComboBoxClearButton"));
function ComboBox(_a) {
    var _this = this;
    var _b, _c, _d, _e;
    var id = _a.id, comboBoxType = _a.comboBoxType, _f = _a.value, value = _f === void 0 ? undefined : _f, defaultValue = _a.defaultValue, _g = _a.options, options = _g === void 0 ? [] : _g, _h = _a.checkboxes, checkboxes = _h === void 0 ? false : _h, _j = _a.canBeCleared, canBeCleared = _j === void 0 ? true : _j, _k = _a.noOptionsText, noOptionsText = _k === void 0 ? 'No options' : _k, _l = _a.loadingText, loadingText = _l === void 0 ? 'Loading...' : _l, _m = _a.ajaxClientSearch, ajaxClientSearch = _m === void 0 ? false : _m, _p = _a.readOnly, readOnly = _p === void 0 ? false : _p, renderOption = _a.renderOption, _q = _a.renderOptionContent, renderOptionContent = _q === void 0 ? function (_o, text) { return text; } : _q, _r = _a.renderInputContent, renderInputContent = _r === void 0 ? function (_o, text) { return text; } : _r, getOptionLabel = _a.getOptionLabel, _s = _a.getOptionText, getOptionText = _s === void 0 ? function (o) {
        if (typeof o === 'string') {
            return o;
        }
        if (typeof o === 'number') {
            return String(o);
        }
        var casted = o;
        return String(casted === null || casted === void 0 ? void 0 : casted.name) || '';
    } : _s, _t = _a.getOptionValue, getOptionValue = _t === void 0 ? function (o) {
        if (typeof o === 'string') {
            return o;
        }
        if (typeof o === 'number') {
            return String(o);
        }
        var casted = o;
        return String(casted === null || casted === void 0 ? void 0 : casted.id) || '';
    } : _t, placeholder = _a.placeholder, name = _a.name, ariaLabel = _a.ariaLabel, onAddValue = _a.onAddValue, onChange = _a.onChange, onFocusOut = _a.onFocusOut, size = _a.size, _u = _a.renderValuesAsTags, renderValuesAsTags = _u === void 0 ? !checkboxes &&
        (ComboBoxOptionUtilities_1.isMultiple(comboBoxType) || comboBoxType === 'single-creatable') : _u;
    var freeText = comboBoxType === 'single-freetext' || comboBoxType === 'multiple-freetext';
    var ajaxQueue = useAjaxQueue_1.default();
    var _v = react_1.default.useState(typeof options === 'function' ? [] : options), fetchedOptions = _v[0], setFetchedOptions = _v[1];
    var _w = react_1.default.useState(false), isLoading = _w[0], setIsLoading = _w[1];
    var _x = react_1.default.useState(undefined), loadingTimer = _x[0], setLoadingTimer = _x[1];
    var optionsToRender = typeof options === 'function' ? fetchedOptions : options;
    var _y = useControlled_1.default({
        controlled: ComboBoxOptionUtilities_1.getSelectedValueFromInput(optionsToRender, getOptionValue || getOptionText, value),
        default: (_b = ComboBoxOptionUtilities_1.getSelectedValueFromInput(optionsToRender, getOptionValue || getOptionText, defaultValue)) !== null && _b !== void 0 ? _b : []
    }), selectedValueControlled = _y[0], setSelectedValue = _y[1];
    var selectedValue = selectedValueControlled;
    var changeSelectedValues = function (newValues) {
        var _a;
        setSelectedValue(newValues);
        if (freeText) {
            setShowClearButton(newValues.length > 0 && !!newValues[0].name);
        }
        if (onChange) {
            onChange(newValues, (!multiple
                ? ((_a = newValues[0]) === null || _a === void 0 ? void 0 : _a.initialObj) || null
                : newValues.map(function (m) { return m.initialObj; })));
        }
    };
    var list = value;
    var argValue = value;
    var _z = react_1.default.useState(!!(freeText && ((argValue === null || argValue === void 0 ? void 0 : argValue.id) || (list === null || list === void 0 ? void 0 : list.length) || (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.length)))), showClearButton = _z[0], setShowClearButton = _z[1];
    var _0 = react_1.default.useState(''), searchDelayed = _0[0], setSearchDelayed = _0[1];
    var _1 = react_1.default.useState(undefined), requestActive = _1[0], setRequestActive = _1[1];
    var _2 = react_1.default.useState(undefined), stateScrollTop = _2[0], setScrollTop = _2[1];
    var _3 = react_1.default.useState(0), page = _3[0], setPage = _3[1];
    var _4 = react_1.default.useState(), nextLink = _4[0], setNextLink = _4[1];
    var multiple = ComboBoxOptionUtilities_1.isMultiple(comboBoxType);
    var initialSearchValue = freeText && !multiple && (selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.length) && ((_c = selectedValue[0]) === null || _c === void 0 ? void 0 : _c.name) !== undefined
        ? selectedValue[0].name
        : '';
    var _5 = react_1.default.useState(false), justOpen = _5[0], setJustOpen = _5[1];
    var _6 = react_1.default.useState(initialSearchValue), search = _6[0], setSearch = _6[1];
    var _7 = react_1.default.useState(0), focusedIndex = _7[0], setFocusedIndex = _7[1];
    var _8 = react_1.default.useState(-1), tagFocusedIndex = _8[0], setTagFocusedIndex = _8[1];
    var _9 = react_1.default.useState(-1), mouseIndex = _9[0], setMouseIndex = _9[1];
    var listboxRef = react_1.default.useRef(null);
    var tagsRef = react_1.default.useRef(null);
    // The search/filter input field
    var inputRef = react_1.default.createRef();
    var autoCompleteInputRef = react_1.default.createRef();
    var autoComplete = comboBoxType === 'single-searchable' ||
        comboBoxType === 'single-creatable' ||
        comboBoxType === 'multiple-searchable';
    var openPopover = function () {
        setTagFocusedIndex(-1);
        if (autoCompleteInputRef === null || autoCompleteInputRef === void 0 ? void 0 : autoCompleteInputRef.current) {
            autoCompleteInputRef.current.value = '';
        }
        if (freeText) {
            if (inputRef.current) {
                setSearch(inputRef.current.value);
            }
        }
        popOver.openPopover();
    };
    var changeFocus = function (newFocusIndex, eventType) {
        setFocusedIndex(newFocusIndex);
        ComboBoxFocus_1.default({ newFocusIndex: newFocusIndex, eventType: eventType, listboxRef: listboxRef });
    };
    react_1.default.useEffect(function () {
        if (!listboxRef.current) {
            return;
        }
        var previousIndex = listboxRef.current.querySelector('[data-focus="true"]');
        if (previousIndex) {
            if (Number(previousIndex === null || previousIndex === void 0 ? void 0 : previousIndex.getAttribute('data-option-index')) !== focusedIndex) {
                previousIndex === null || previousIndex === void 0 ? void 0 : previousIndex.removeAttribute('data-focus');
            }
        }
        var option = listboxRef.current.querySelector("[data-option-index=\"" + focusedIndex + "\"]");
        if (!option) {
            return;
        }
        option.setAttribute('data-focus', 'true');
        // eslint-disable-next-line consistent-return
        return function () {
            // If components unmounts we need to cancel queued up work so that we don't try to update the UI after unmounting.
        };
    });
    react_1.default.useEffect(function () {
        return function () {
            autocompleteSearchThrottled.cancel();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Focus tags
    react_1.default.useEffect(function () {
        if (!tagsRef.current) {
            return;
        }
        var previousIndex = tagsRef.current.querySelector('[data-tag-focus="true"]');
        if (previousIndex) {
            if (Number(previousIndex === null || previousIndex === void 0 ? void 0 : previousIndex.getAttribute('data-tag-index')) !== tagFocusedIndex) {
                previousIndex === null || previousIndex === void 0 ? void 0 : previousIndex.removeAttribute('data-tag-focus');
            }
        }
        var option = tagsRef.current.querySelector("[data-tag-index=\"" + tagFocusedIndex + "\"]");
        if (!option) {
            return;
        }
        option.setAttribute('data-tag-focus', 'true');
    });
    //   const setFocus = useEventCallback((index)) => {
    //     React.useEffect(() => {
    //       if (!listboxRef.current) {
    //         return;
    //       }
    //       const option = listboxRef.current.querySelector(`[data-option-index="${index}"]`);
    //       if (!option) {
    //         return;
    //       }
    //       option.setAttribute('data-focus', 'true');
    //     });
    // setFocus(highlightedIndexRef.current);
    var defaultGetOptionLabel = function (o) {
        if (!o) {
            return '';
        }
        var obj = o;
        if (obj.name) {
            return String(obj.name);
        }
        return o;
    };
    var getOptionNameFunc = getOptionLabel || defaultGetOptionLabel;
    var renderOptionFunc = renderOption || (checkboxes ? ComboBoxOption_1.defaultRenderCheckboxOption : ComboBoxOption_1.defaultRenderOption);
    var autocompleteSearch = function (autoSearch, indexOption) {
        // Reset everything
        setPage(0);
        setSearchDelayed(autoSearch);
        ajaxQueue.startNewSession();
        // Client search
        var newOptions = createFilteredOptionsBySearch(autoSearch);
        if (newOptions.length <= indexOption && newOptions.length >= 0) {
            setFocusedIndex(0);
        }
    };
    var handleMouseOverOption = function (event) {
        if (event.currentTarget) {
            var newFocusIndex = Number(event.currentTarget.getAttribute('data-option-index'));
            if (newFocusIndex !== mouseIndex) {
                if (newFocusIndex >= 0) {
                    changeFocus(newFocusIndex, 'mouse');
                }
                setMouseIndex(newFocusIndex);
            }
        }
    };
    var autocompleteSearchThrottled = react_1.useCallback(throttle_debounce_1.debounce(typeof options === 'function' ? 250 : 0, autocompleteSearch), []);
    var changeQuery = function (event) {
        if (autoComplete || freeText) {
            var newValue = event.target.value;
            setSearch(newValue);
            if (typeof options !== 'function') {
                autocompleteSearch(newValue, focusedIndex);
            }
            else {
                autocompleteSearchThrottled(newValue, focusedIndex);
            }
        }
        if (freeText) {
            var newValue = event.target.value;
            if (newValue !== '' && !popOver.isOpen) {
                openPopover();
            }
            if (comboBoxType === 'single-freetext') {
                setShowClearButton(newValue.length > 0);
                if (onChange) {
                    onChange([{ id: newValue, name: newValue, internalId: newValue, selected: false, label: newValue }], {
                        id: newValue,
                        name: newValue,
                        internalId: newValue,
                        selected: false,
                        label: newValue
                    } || null);
                }
            }
        }
    };
    var clearAllValues = function () {
        // Clear input when uncontrolled
        if (inputRef.current && freeText && value === undefined) {
            inputRef.current.value = '';
        }
        setSearch('');
        changeSelectedValues([]);
        popOver.close();
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };
    var addNewSelectedValue = function (obj) {
        if (multiple) {
            var alreadyExists = selectedValue.filter(function (item) {
                if (item.id === obj.id) {
                    return true;
                }
                if (freeText && item.name === obj.name) {
                    return true;
                }
                return false;
            }).length;
            if (!alreadyExists) {
                changeSelectedValues(__spreadArrays(selectedValue, [obj]));
            }
            else if (checkboxes) {
                changeSelectedValues(selectedValue.filter(function (item) {
                    return item.id !== obj.id;
                }));
            }
            else if (comboBoxType === 'multiple-freetext') {
                if (inputRef.current) {
                    inputRef.current.value = '';
                }
            }
        }
        else {
            changeSelectedValues([obj]);
        }
        if (!checkboxes) {
            popOver.close();
            if (tagFocusedIndex !== -1 && multiple) {
                setTagFocusedIndex(selectedValue.length);
            }
        }
    };
    var removeTag = function (o) {
        var selectedValueList = selectedValue;
        var index = 0;
        var filtedTagList = selectedValueList.filter(function (item) {
            index += 1;
            return (item.internalId || item.id) !== (o.internalId || o.id);
        });
        changeSelectedValues(filtedTagList);
        // If tag with focus is removed, keep same focus index
        // if tag before is removed, subtract 1 so same tag is focused
        // If tag after is removed, change nothing
        // If nothing is focused, change nothing
        if (index < tagFocusedIndex) {
            setTagFocusedIndex(tagFocusedIndex - 1);
            return;
        }
        // Remove focus index if no tags remain
        if (filtedTagList.length === 0) {
            setTagFocusedIndex(-1);
        }
        inputRef.current.focus();
    };
    react_1.default.useEffect(function () {
        if (justOpen) {
            setJustOpen(false);
            if (freeText && inputRef.current) {
                var valFreeTextTabIndex = inputRef.current.tabIndex;
                inputRef.current.tabIndex = -1;
                // inputRef.current.focus();
                inputRef.current.tabIndex = valFreeTextTabIndex;
            }
            else if (autoCompleteInputRef === null || autoCompleteInputRef === void 0 ? void 0 : autoCompleteInputRef.current) {
                // Remove tab index to prevent browser to jump to focused field
                var val = autoCompleteInputRef.current.tabIndex;
                autoCompleteInputRef.current.tabIndex = -1;
                autoCompleteInputRef.current.focus({
                    preventScroll: true
                });
                autoCompleteInputRef.current.tabIndex = val;
            }
        }
    }, [justOpen, autoCompleteInputRef, freeText, inputRef]);
    var createFilteredOptionsBySearch = function (searchValue) {
        var input = (searchValue === null || searchValue === void 0 ? void 0 : searchValue.trim()) || '';
        input = input.toLowerCase();
        input = StringUtilities_1.default(input);
        var filteredOptions = [];
        if (optionsToRender && optionsToRender.length) {
            filteredOptions = optionsToRender
                .map(function (option) {
                var optionId = getOptionValue(option) || getOptionText(option);
                var optionName = getOptionText(option) || getOptionValue(option);
                // getOptionIdFunc((option as unknown) as ComboBoxValue);
                // const optionName = getOptionNameFunc((option as unknown) as ComboBoxValue);
                var selected = !!(selectedValue &&
                    multiple &&
                    selectedValue.filter(function (item) {
                        if (item.id === optionId) {
                            return true;
                        }
                        if (freeText && String(item.name) === optionName) {
                            return true;
                        }
                        return false;
                    }).length > 0);
                if (typeof option === 'object' && option !== undefined) {
                    return __assign(__assign({}, option), { initialObj: option, internalId: ComboBoxOptionUtilities_1.generateOptionId(), id: optionId, name: optionName, selected: selected });
                }
                var builtInType = {
                    initialObj: option,
                    internalId: ComboBoxOptionUtilities_1.generateOptionId(),
                    id: optionId,
                    name: optionName,
                    selected: selected
                };
                return builtInType;
            })
                .filter(function (option) {
                if (!option) {
                    return false;
                }
                if (!ajaxClientSearch && typeof options === 'function') {
                    return true;
                }
                var candidate = StringUtilities_1.default(option.name.toLowerCase ? option.name.toLowerCase() : String(option.name));
                var candidateId = StringUtilities_1.default(String(option.id).toLowerCase());
                return ((candidate.indexOf(input) > -1 || candidateId.indexOf(input) === 0) &&
                    (checkboxes || !option.selected));
            });
        }
        if (searchValue !== '' && (comboBoxType === 'single-creatable' || comboBoxType === 'multiple-freetext')) {
            // TODO, remove white space
            filteredOptions.push({
                internalId: ComboBoxOptionUtilities_1.generateOptionId(),
                id: searchValue,
                name: searchValue,
                label: "Add \"" + searchValue + "\"",
                selected: false,
                newValue: true
            });
        }
        return filteredOptions;
    };
    var createFilteredOptions = function () {
        return createFilteredOptionsBySearch(search);
    };
    var selectOptionFromIndex = function (optionIndex) {
        var filteredOptions = createFilteredOptions();
        if (filteredOptions[optionIndex].newValue && onAddValue) {
            onAddValue(filteredOptions[optionIndex]);
        }
        else {
            addNewSelectedValue(filteredOptions[optionIndex]);
            if (comboBoxType === 'single-freetext' && inputRef.current) {
                if (!multiple) {
                    inputRef.current.value = filteredOptions[optionIndex].name;
                    setSearch(inputRef.current.value);
                    if (!checkboxes) {
                        popOver.close();
                    }
                }
                else {
                    inputRef.current.value = '';
                }
            }
        }
        popOver.refreshPosition();
        // Need to keep either autocomplete or input focused after selecting value
        if (autoComplete && !freeText && checkboxes) {
            if (autoCompleteInputRef.current) {
                autoCompleteInputRef.current.focus();
            }
        }
        else if (inputRef.current) {
            inputRef.current.focus();
        }
        // After selecting the last value the previous item should get focus, since there is no next item
        if (!checkboxes && multiple) {
            if (focusedIndex >= filteredOptions.length - 1 && focusedIndex > 0) {
                changeFocus(focusedIndex - 1, 'change');
            }
        }
    };
    var filtedOptions = createFilteredOptions();
    var freeTextInputCssClass = [
        autoComplete && !freeText && 'c-form-control',
        'skip-validation',
        size && "c-form-control--" + size
    ]
        .filter(Boolean)
        .join(' ');
    var popOver = Popover_1.usePopover({
        cssClass: 'c-overlay--combobox',
        showArrow: false,
        openOn: freeText ? 'click' : 'click',
        closeOn: 'click',
        fullWidth: true,
        onOpen: function () {
            if (autoCompleteInputRef === null || autoCompleteInputRef === void 0 ? void 0 : autoCompleteInputRef.current) {
                autoCompleteInputRef.current.value = '';
                setSearchDelayed('');
            }
            if (typeof options === 'function') {
                setFetchedOptions([]);
                setPage(0);
            }
            if (!freeText) {
                setSearch('');
            }
            var tmp = selectedValue && selectedValue.length ? selectedValue[0].id : undefined;
            if (tmp) {
                var newIndex_1 = -1;
                // Check if current focus is selected
                if (focusedIndex >= 0 && focusedIndex < filtedOptions.length) {
                    var currentOption_1 = filtedOptions[focusedIndex];
                    selectedValue.forEach(function (v) {
                        if (v.id === currentOption_1.id) {
                            newIndex_1 = focusedIndex;
                        }
                    });
                }
                // Try to find selected item
                if (newIndex_1 === -1) {
                    filtedOptions.forEach(function (v, index) {
                        if (String(v.id) === String(tmp)) {
                            newIndex_1 = index;
                        }
                    });
                }
                // First item should be selected if available items exists
                if (newIndex_1 === -1 && filtedOptions.length) {
                    newIndex_1 = 0;
                }
                if (multiple && !checkboxes) {
                    // Do nothjing
                }
                else {
                    setFocusedIndex(newIndex_1);
                }
            }
            ajaxQueue.startNewSession();
            setJustOpen(true);
        },
        onClose: function () {
            var _a;
            setJustOpen(false);
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            if (autoCompleteInputRef.current) {
                autoCompleteInputRef.current.value = '';
                setSearchDelayed('');
                if (!freeText) {
                    setSearch('');
                }
            }
        },
        effect: 'none',
        keepOpenOnHover: true,
        content: function () {
            var searchValue = search;
            var input = (searchValue === null || searchValue === void 0 ? void 0 : searchValue.trim()) || '';
            input = input.toLowerCase();
            input = StringUtilities_1.default(input);
            // const filteredOptions: T[] = (createFilteredOptions() as unknown) as T[];
            var filteredOptions = createFilteredOptions();
            var isAjax = typeof options === 'function' && (ajaxQueue.isRequestActive() || ajaxQueue.morePagesExists());
            if (filteredOptions.length === 0 && !isAjax && freeText) {
                return null;
            }
            //   const loading = fetchedOptions.length === 0 && content.isOpen && typeof options === 'function';
            //   if (loading !== isLoading) {
            //     setIsLoading(loading);
            //   }
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "c-dropdown-menu c-dropdown-menu--option-menu", role: "none", onKeyDown: function (e) {
                        handleKeyDown(e);
                    } },
                    react_1.default.createElement("input", { ref: autoCompleteInputRef, name: "AutoComplete", "aria-label": "AutoComplete", "aria-invalid": "false", autoComplete: "off", className: freeTextInputCssClass, style: autoComplete && !freeText
                            ? {}
                            : { opacity: '0', position: 'absolute', width: '1px', height: '1px' }, type: "text", "aria-autocomplete": "list", autoCapitalize: "none", spellCheck: "false", onChange: changeQuery }),
                    filteredOptions.length === 0 && noOptionsText && !isLoading && (react_1.default.createElement("div", { className: "c-dropdown-menu__item disabled" }, noOptionsText)),
                    react_1.default.createElement("div", { className: "c-dropdown-menu__options", ref: listboxRef, onScroll: function () {
                            if (!ajaxQueue.morePagesExists()) {
                                return;
                            }
                            var listboxNode = listboxRef.current;
                            var scrollInBottom = listboxNode.scrollTop + listboxNode.clientHeight >= listboxNode.scrollHeight - 150 &&
                                listboxNode.clientHeight > 0; // ClientHeight larger then zero is for unit testing purpose
                            if (scrollInBottom) {
                                setScrollTop(listboxRef.current.scrollTop);
                            }
                        } },
                        loadingText && isLoading && page === 0 && (react_1.default.createElement("div", { className: "c-dropdown-menu__item disabled" },
                            loadingText,
                            " ")),
                        filteredOptions.map(function (option, index) {
                            var attr = {
                                onMouseUp: function (event) {
                                    // Prevent action to be called twice
                                    event.preventDefault();
                                    event.stopPropagation();
                                    var optionIndex = Number(event.currentTarget.getAttribute('data-option-index'));
                                    selectOptionFromIndex(optionIndex);
                                }
                            };
                            return (renderOptionFunc &&
                                renderOptionFunc(option, index, focusedIndex, handleMouseOverOption, attr, renderOptionContent, getOptionText));
                        }),
                        loadingText && isLoading && page > 0 && ajaxQueue.isRequestActive() && (react_1.default.createElement("div", { className: "c-dropdown-menu__item disabled" }, loadingText))))));
        }
    });
    var scrollTop = (_d = listboxRef === null || listboxRef === void 0 ? void 0 : listboxRef.current) === null || _d === void 0 ? void 0 : _d.scrollTop;
    var loadUsingAjax = function (fetchPage, loadedItems, fetchOptions) {
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var queueItem, obj, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setRequestActive(searchDelayed);
                        if (loadingTimer) {
                            clearTimeout(loadingTimer);
                        }
                        setIsLoading(true);
                        queueItem = ajaxQueue.addQueueItem(search + String((page || 0) + 1));
                        obj = {
                            page: fetchPage,
                            nextLink: fetchPage > 1 ? nextLink : undefined,
                            data: undefined,
                            loadedItems: loadedItems,
                            filteredItems: loadedItems,
                            search: searchDelayed,
                            setAbortAjax: function (cancelFunction) {
                                queueItem.abortAjax = cancelFunction;
                            }
                        };
                        return [4 /*yield*/, fetchOptions(obj)];
                    case 1:
                        response = _a.sent();
                        queueItem.more = response.more;
                        queueItem.nextLink = response.nextLink;
                        ajaxQueue.requestCompleted(queueItem);
                        if (ajaxQueue.newerRequestCompleted(queueItem)) {
                            // Dont render result if a more accurate result already been rendered
                            // Depends on order ajax requests are completed
                            return [2 /*return*/];
                        }
                        if (fetchPage === 1) {
                            setFetchedOptions(response.items);
                            popOver.refreshPosition();
                        }
                        else {
                            setFetchedOptions(__spreadArrays(fetchedOptions, response.items));
                            popOver.refreshPosition();
                        }
                        setPage(page + 1);
                        setNextLink(response.nextLink);
                        if (searchDelayed === requestActive) {
                            setRequestActive(undefined);
                        }
                        if (!queueItem.more) {
                            setIsLoading(false);
                        }
                        setLoadingTimer(window.setTimeout(function () {
                            setIsLoading(false);
                        }, 1000));
                        return [2 /*return*/];
                }
            });
        }); })();
    };
    react_1.default.useEffect(function () {
        if (typeof options !== 'function') {
            return;
        }
        // Don't make ajax request if popup is closed
        if (!popOver.isOpen) {
            return;
        }
        // Don't make same request twice
        if (ajaxQueue.isLatestRequest(searchDelayed + (page + 1))) {
            return;
        }
        if (!ajaxQueue.morePagesExists()) {
            return;
        }
        if (listboxRef.current) {
            var listboxNode = listboxRef.current;
            var threshold = 150; // Load next page before reaching bottom of scroll
            var scrollInBottom = listboxNode.scrollTop + listboxNode.clientHeight >= listboxNode.scrollHeight - threshold &&
                listboxNode.clientHeight > 0; // ClientHeight larger then zero is for unit testing purpose
            if (scrollInBottom || ajaxQueue.firstRequestOnNewSession()) {
                // Don't load second page until first page finished
                if (page > 0 && !ajaxQueue.lastPageCompleted() && ajaxQueue.morePagesExists()) {
                    return;
                }
                loadUsingAjax(page + 1, ajaxQueue.firstRequestOnNewSession() ? 0 : fetchedOptions.length, options);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ajaxQueue.sessionId, ajaxQueue.numCompletedRequest, page, popOver.isOpen, scrollTop, stateScrollTop]);
    // [page, searchDelayed, hasMoreOptions, popOver.isOpen, isLoading, requestActive, scrollTop]);
    //   React.useEffect(() => {
    //     if (!popOver.isOpen) {
    //       setPage(1);
    //       setHasMoreOptions(false);
    //       setFetchedOptions([]);
    //     }
    //   }, [popOver.isOpen]);
    //   const setHighlightedIndex = useEventCallback((index: unknown) => {
    //     const option = listboxRef.current?.querySelector(`[data-option-index="${index}"]`);
    //     if (!option) {
    //       return;
    //     }
    //     option.setAttribute('data-focus', 'true');
    //   });
    //   const syncHighlightedIndex = React.useCallback(() => {
    //     if (!popOver.isOpen) {
    //       return;
    //     }
    //     setHighlightedIndex(highlightedIndexRef.current);
    //   }, [popOver.isOpen, setHighlightedIndex]);
    //   syncHighlightedIndex();
    var handleKeyDown = function (event) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        var focusedItemPreEvent = listboxRef.current && listboxRef.current.querySelector('[data-focus="true"]');
        var filteredOptions = createFilteredOptions();
        var tagHasFocus = tagFocusedIndex >= 0 && tagFocusedIndex < selectedValue.length;
        // User is searching if input field have focus
        var userIsSearching = freeText || (!freeText && autoComplete);
        // You can not select values with space if autocomplete input or freetext input is focused
        var toggleTagsWithSpace = !autoComplete && !freeText;
        if (checkboxes) {
            if (autoComplete) {
                // If cursor is in start of autocomplete input, then you are allowed to select with space
                if (((_a = autoCompleteInputRef.current) === null || _a === void 0 ? void 0 : _a.selectionStart) === ((_b = autoCompleteInputRef.current) === null || _b === void 0 ? void 0 : _b.selectionEnd) &&
                    (((_c = autoCompleteInputRef.current) === null || _c === void 0 ? void 0 : _c.selectionEnd) === 0 ||
                        ((_d = autoCompleteInputRef.current) === null || _d === void 0 ? void 0 : _d.selectionEnd) === ((_e = autoCompleteInputRef.current) === null || _e === void 0 ? void 0 : _e.value.length))) {
                    toggleTagsWithSpace = true;
                }
            }
        }
        var inputValueIsSelectedValue = false;
        if (multiple) {
            selectedValue.forEach(function (valueObj) {
                var _a;
                if (getOptionNameFunc(valueObj) === ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.value)) {
                    inputValueIsSelectedValue = true;
                }
            });
        }
        var insideText = (freeText &&
            inputRef.current &&
            inputRef.current.selectionStart &&
            inputRef.current.selectionStart > 0) ||
            (multiple &&
                autoCompleteInputRef.current &&
                autoCompleteInputRef.current.selectionStart &&
                autoCompleteInputRef.current.selectionStart > 0);
        switch (event.key) {
            case 'Home': {
                if (popOver.isOpen) {
                    if (!userIsSearching) {
                        // Prevent browser scroll when input field does not have focus
                        event.preventDefault();
                    }
                    changeFocus(0, 'keydown');
                }
                break;
            }
            case 'End': {
                if (popOver.isOpen) {
                    // Prevent browser scroll
                    // If free text, then textfield have focus
                    if (!freeText && !userIsSearching) {
                        event.preventDefault();
                    }
                    changeFocus(filteredOptions.length - 1, 'keydown');
                }
                break;
            }
            case 'Tab': {
                popOver.close();
                if (event.shiftKey && popOver.isOpen) {
                    // Do not focus previous element if popover is open
                    event.preventDefault();
                }
                break;
            }
            case 'Escape':
                if (popOver.isOpen) {
                    popOver.close();
                    // Prevent dialog from closing if combobox is in a dialog
                    event.stopPropagation();
                }
                break;
            case ' ':
                // key = Spacebar
                if (event.target.classList.contains('c-chip__close')) {
                    return;
                }
                if (!popOver.isOpen) {
                    openPopover();
                    return;
                }
                // Wait until IME is settled.
                if (event.which === 229) {
                    break;
                }
                if (toggleTagsWithSpace && focusedItemPreEvent) {
                    selectOptionFromIndex(Number(focusedItemPreEvent.getAttribute('data-option-index')));
                    event.preventDefault();
                    event.stopPropagation();
                }
                break;
            case 'Delete':
            case 'Backspace':
                // Remove tag with focus
                if (tagHasFocus && !popOver.isOpen) {
                    removeTag(selectedValue[tagFocusedIndex]);
                }
                else if (!popOver.isOpen && !freeText && (canBeCleared || multiple)) {
                    // Remove last tag
                    if (multiple && event.key === 'Backspace') {
                        var numTags = selectedValue.length;
                        // Remove last tag
                        removeTag(selectedValue[numTags - 1]);
                    }
                    else {
                        // Remove all values
                        clearAllValues();
                    }
                }
                if (!tagHasFocus && multiple && freeText && !((_f = inputRef.current) === null || _f === void 0 ? void 0 : _f.value) && event.key === 'Backspace') {
                    var numTags = selectedValue.length;
                    // Remove last tag
                    removeTag(selectedValue[numTags - 1]);
                }
                if (tagHasFocus && freeText) {
                    event.preventDefault(); // Do not delete letter in input field
                }
                break;
            case 'Enter':
                if (event.target.classList.contains('c-chip__close')) {
                    return;
                }
                if (!popOver.isOpen) {
                    openPopover();
                    return;
                }
                // If combobox is inside a form with submit button, prevent form from being submitted
                event.preventDefault();
                // Wait until IME is settled.
                if (event.which === 229) {
                    break;
                }
                if (autoComplete) {
                    (_g = inputRef.current) === null || _g === void 0 ? void 0 : _g.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                }
                if (focusedItemPreEvent) {
                    // We should only do this if we filter out selected items
                    selectOptionFromIndex(Number(focusedItemPreEvent.getAttribute('data-option-index')));
                }
                if (!inputValueIsSelectedValue && freeText && multiple && inputRef.current) {
                    var label = (_h = inputRef.current) === null || _h === void 0 ? void 0 : _h.value;
                    if (label) {
                        inputRef.current.value = '';
                    }
                }
                break;
            case 'ArrowUp':
                // Prevent browser scroll
                event.preventDefault();
                if (!popOver.isOpen) {
                    openPopover();
                    return;
                }
                // Change focus
                if (focusedIndex > 0) {
                    changeFocus(focusedIndex - 1, 'keydown');
                }
                else {
                    changeFocus(filteredOptions.length - 1, 'keydown');
                }
                break;
            case 'ArrowDown':
                // Prevent browser scroll
                event.preventDefault();
                if (!popOver.isOpen) {
                    openPopover();
                    return;
                }
                // Change focus
                if (focusedIndex < filteredOptions.length - 1) {
                    changeFocus(focusedIndex + 1, 'keydown');
                }
                else {
                    changeFocus(0, 'keydown');
                }
                break;
            case 'ArrowLeft':
                if (insideText) {
                    // Navigating inside text in input field, no need to change focus
                    return;
                }
                if (event.shiftKey) {
                    // Navigating inside text in input field, no need to change focus
                    return;
                }
                if (renderValuesAsTags && multiple) {
                    // Prevent horizontal browser scroll (Not very likely, but just in case)
                    if (!freeText) {
                        event.preventDefault();
                    }
                    if (popOver.isOpen) {
                        popOver.close();
                    }
                    // Change focus
                    if (tagFocusedIndex > 0) {
                        setTagFocusedIndex(tagFocusedIndex - 1);
                    }
                    if (tagFocusedIndex === -1) {
                        setTagFocusedIndex(selectedValue.length - 1);
                    }
                }
                break;
            case 'ArrowRight':
                if (freeText && ((_k = (_j = inputRef.current) === null || _j === void 0 ? void 0 : _j.value) === null || _k === void 0 ? void 0 : _k.length) && tagFocusedIndex === -1) {
                    // Navigating inside text in input field, no need to change focus
                    return;
                }
                if (multiple && ((_m = (_l = autoCompleteInputRef.current) === null || _l === void 0 ? void 0 : _l.value) === null || _m === void 0 ? void 0 : _m.length) && tagFocusedIndex === -1) {
                    // Navigating inside text in input field, no need to change focus
                    return;
                }
                if (event.shiftKey) {
                    // Navigating inside text in input field, no need to change focus
                    return;
                }
                if (renderValuesAsTags && multiple) {
                    // Prevent horizontal browser scroll (Not very likely, but just in case)
                    if (!freeText) {
                        event.preventDefault();
                    }
                    if (!popOver.isOpen && tagFocusedIndex === -1) {
                        openPopover();
                        return;
                    }
                    // Close popover when changing focus on tabs
                    // Question: What about freeText and when input is focused?
                    if (popOver.isOpen) {
                        popOver.close();
                    }
                    // Change focus
                    if (tagFocusedIndex >= 0 && tagFocusedIndex < selectedValue.length - 1) {
                        setTagFocusedIndex(tagFocusedIndex + 1);
                    }
                    else {
                        setTagFocusedIndex(-1);
                    }
                    if (tagFocusedIndex >= 0) {
                        event.preventDefault(); // Do not change position of cursor
                    }
                }
                break;
        }
    };
    var hasValue = !!((!freeText && selectedValue && ((_e = selectedValue) === null || _e === void 0 ? void 0 : _e.length)) ||
        showClearButton);
    var isDropDownOpen = popOver.isOpen && (filtedOptions.length || !freeText);
    var isFreeTextDropDown = comboBoxType === 'single-freetext' || (comboBoxType === 'multiple-freetext' && options.length === 0); // TODO: Check if function
    var inputCssClass = [
        'c-form-control',
        'c-form-control--select',
        size && "c-form-control--" + size,
        readOnly && 'c-form-control--readonly',
        isDropDownOpen && 'c-form-control--open',
        isFreeTextDropDown && 'c-form-control--free-text'
    ]
        .filter(Boolean)
        .join(' ');
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "c-combo-box " + (popOver.isOpen ? ' c-combo-box--open' : ''), onBlur: function (e) {
                var _a, _b, _c;
                if (e.target === e.relatedTarget) {
                    // Focusing the same element should not trigger blur
                    return;
                }
                var focusOptions = selectedValueControlled;
                if (!e.relatedTarget || !e.currentTarget.contains(e.relatedTarget)) {
                    onFocusOut &&
                        onFocusOut(selectedValue, (!multiple
                            ? (((_a = focusOptions[0]) === null || _a === void 0 ? void 0 : _a.initialObj) || ((_b = focusOptions[0]) === null || _b === void 0 ? void 0 : _b.id) ||
                                focusOptions[0]) || null
                            : focusOptions.map(function (m) { return m.initialObj || (m === null || m === void 0 ? void 0 : m.id) || m; })));
                }
                // If blur was triggered because we are trying to remove a tag, then don't remove tag focus, another tag should get focus
                var relatedButtonTarget = e.relatedTarget;
                var clickedRemovedButton = relatedButtonTarget &&
                    relatedButtonTarget.tagName === 'BUTTON' && ((_c = relatedButtonTarget.parentElement) === null || _c === void 0 ? void 0 : _c.hasAttribute('data-tag-index'));
                if (!clickedRemovedButton) {
                    setTagFocusedIndex(-1);
                }
                var element = e.relatedTarget;
                var parentElement = (element === null || element === void 0 ? void 0 : element.parentElement) || element;
                // Do not open popovers if users clicks on close/clear buttons
                if (!element ||
                    (!element.classList.contains('c-dropdown-menu__item') &&
                        !parentElement.classList.contains('c-dropdown-menu__item'))) {
                    if (multiple && freeText && inputRef.current) {
                        // We can not clear search here since it will cause issue when selecting option with mouse
                        inputRef.current.value = '';
                        setSearch('');
                    }
                }
            } },
            react_1.default.createElement("div", { className: inputCssClass, role: "none", ref: popOver.triggerRef, onMouseEnter: popOver.onTriggerMouseEnter, onMouseLeave: popOver.onTriggerMouseLeave, onKeyDown: function (e) {
                    handleKeyDown(e);
                }, onClick: function (e) {
                    e.preventDefault();
                    if (readOnly)
                        return;
                    var element = e.target;
                    var parentElement = element.parentElement || element;
                    // Do not open popovers if users clicks on close/clear buttons
                    if (!element.classList.contains('c-form-control__clear') &&
                        !parentElement.classList.contains('c-form-control__clear') &&
                        !element.classList.contains('c-chip__close') &&
                        !parentElement.classList.contains('c-chip__close')) {
                        popOver.onTriggerClick(e);
                    }
                } },
                react_1.default.createElement("div", { className: "c-form-control__tags", ref: tagsRef },
                    multiple && renderValuesAsTags && selectedValue && (react_1.default.createElement(ComboBoxTags_1.default, { tagFocusedIndex: tagFocusedIndex, selectedValues: selectedValue, onRemoveClick: removeTag, displayValue: getOptionNameFunc })),
                    react_1.default.createElement(ComboBoxInput_1.default, { id: id, renderValuesAsTags: renderValuesAsTags, selectedValues: selectedValue, ariaLabel: ariaLabel, comboBoxType: comboBoxType, readOnly: readOnly, inputRef: inputRef, onClearTagFocus: function () { return setTagFocusedIndex(-1); }, onFreeTextChangeQuery: function (e) {
                            setShowClearButton(e.showClearButton);
                            changeQuery(e.event);
                        }, placeholder: placeholder, name: name, "aria-label": ariaLabel, value: value, renderInputContent: renderInputContent, getOptionText: getOptionText })),
                hasValue && canBeCleared && !readOnly && react_1.default.createElement(ComboBoxClearButton_1.default, { onClick: clearAllValues }),
                react_1.default.createElement("span", { className: "c-form-control__drop", tabIndex: -1 })),
            popOver.overlay)));
}
exports.ComboBox = ComboBox;
exports.default = ComboBox;
